import { render } from "./Editor.vue?vue&type=template&id=4d11eb13"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Editor.vue?vue&type=style&index=0&id=4d11eb13&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__